import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export type LoadingMessageType = 'default' | 'fit-content';

@Component({
  selector: 'mbp-loading-message',
  templateUrl: './loading-message.component.html',
  styleUrls: ['./loading-message.component.scss'],
  imports: [TranslateModule]
})
export class LoadingMessageComponent {
  message = input<string>('general.loading');
  type = input<LoadingMessageType>('default');
}
